import { get } from 'lodash';
import { verifyOrFallbackColor } from './verify-or-fallback';
import { toRgbAsHex } from './color';
import * as defaults from './defaults';
export const getEmailBackgroundColor = (composerData) => verifyOrFallbackColor(defaults.defaultBackgroundColor)(toRgbAsHex(get(composerData, 'background.data.color.value') ||
    get(composerData, 'styles.css.so-global-background-color.backgroundColor')));
//# sourceMappingURL=get-email-background-color.js.map